import api, {handleAPIErrors} from 'shared/api'
import {buildFormData} from "shared/utilities"

const FETCH_REQUEST = 'jobApplications/FETCH_REQUEST'
const FETCH_SUCCESS = 'jobApplications/FETCH_SUCCESS'
const FETCH_FAILURE = 'jobApplications/FETCH_FAILURE'
const UPDATE_REQUEST = 'jobApplications/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'jobApplications/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'jobApplications/UPDATE_FAILURE'
const START_CONVERSATION_REQUEST = 'jobApplications/START_CONVERSATION_REQUEST'
const START_CONVERSATION_SUCCESS = 'jobApplications/START_CONVERSATION_SUCCESS'
const START_CONVERSATION_FAILURE = 'jobApplications/UPDATE_FAILURE'
const ADD_NOTES_REQUEST = 'jobs/ADD_NOTES_REQUEST'
const ADD_NOTES_SUCCESS = 'jobs/ADD_NOTES_SUCCESS'
const ADD_NOTES_FAILURE = 'jobs/ADD_NOTES_FAILURE'
const UPLOAD_REQUEST = 'jobApplications/UPLOAD_REQUEST'
const UPLOAD_SUCCESS = 'jobApplications/UPLOAD_SUCCESS'
const UPLOAD_FAILURE = 'jobApplications/UPLOAD_FAILURE'

const initialState = {
  result: {job_applications: [], potential_candidates: [], suggested_applicants: []},
  loading: false,
  loaded: false,
  updating: false,
  updated: false,
  addingNotes: false, 
  addedNotes: false,
  uploading: false,
  uploaded: false,
  errors: {}
}

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  }
}

export function updateFailure(errors) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function startConversationRequest() {
  return {
    type: START_CONVERSATION_REQUEST,
  }
}

export function startConversationSuccess(payload) {
  return {
    type: START_CONVERSATION_SUCCESS,
    payload,
  }
}

export function startConversationFailure(errors) {
  return {
    type: START_CONVERSATION_FAILURE,
    errors,
  }
}

export function addNotesRequest() {
  return {
    type: ADD_NOTES_REQUEST,
  }
}

export function addNotesSuccess(payload) {
  return {
    type: ADD_NOTES_SUCCESS,
    payload,
  }
}

export function addNotesFailure(errors) {
  return {
    type: ADD_NOTES_FAILURE,
    errors,
  }
}

export function uploadRequest() {
  return {
    type: UPLOAD_REQUEST,
  }
}

export function uploadSuccess(payload) {
  return {
    type: UPLOAD_SUCCESS,
    payload,
  }
}

export function uploadFailure(errors) {
  return {
    type: UPLOAD_FAILURE,
    errors,
  }
}

export function loadData(id, options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/jobs/${id}`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })
  }
}

export function updateData(options, cb = null) {
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch, getState) => {
    const state = getState()
    const { jobApplications } = state
    dispatch(updateRequest())

    return api(`api/v1/jobs/${jobApplications.result.id}`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateFailure(errors))
        })
      })
  }
}

export function updatePotentialCandidate(options, cb) {
  const form = new FormData()
  buildFormData(form, options)

  const config = {
    method: 'PUT',
    body: form
  }

  return (dispatch, getState) => {
    const state = getState()
    const { jobApplications } = state
    dispatch(updateRequest())

    return api(`api/v1/jobs/${jobApplications.result.id}`, {}, config, false, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))

        cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateFailure(errors))
        })
      })
  }
}

export function uploadCV(options, id, keyName, cb = null) {
  const form = new FormData()
  buildFormData(form, options)

  const config = {
    method: 'PUT',
    body: form
  }

  return (dispatch, getState) => {
    const state = getState()
    const { jobApplications } = state
    dispatch(uploadRequest())

    return api(`api/v1/jobs/${jobApplications.result.id}`, {}, config, false, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(uploadSuccess(json))

        if (cb){
          let jobApplication
          if(keyName === 'job_applications_attributes'){
            jobApplication = json.job_applications.find((app) => app.id === Number(id))
          }else{
            jobApplication = json.potential_candidates.find((pc) => pc.id === Number(id))
          }
          cb(jobApplication.cv_location)
        }
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(uploadFailure(errors))
        })
      })
  }
}

export function uploadMultipleFiles(keyName, name, id, files, cb = null) {
  let form
  const isFormData = files.length > 0

  if(files.length > 0){
    form = new FormData()
    files.forEach((file) => form.append(`jobs[${keyName}][0][${name}][]`, file))
    form.append(`jobs[${keyName}][0][id]`, id)
    form.append("include_job_applications", 'true')
    form.append("include_potential_candidates", 'true')
  }else{
    form = JSON.stringify({
      jobs: {
        [keyName]: {
          [name]: [],
          id: id
        }
      },
      include_job_applications: true,
      include_potential_candidates: true
    })
  }


  const config = {
    method: 'PUT',
    body: form
  }

  return (dispatch, getState) => {
    const state = getState()
    const { jobApplications } = state
    dispatch(uploadRequest())

    return api(`api/v1/jobs/${jobApplications.result.id}`, {}, config, false, isFormData)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(uploadSuccess(json))

        if (cb){
          let jobApplication
          if(keyName === 'job_applications_attributes'){
            jobApplication = json.job_applications.find((app) => app.id === Number(id))
          }else{
            jobApplication = json.potential_candidates.find((pc) => pc.id === Number(id))
          }
          cb(jobApplication)
        }
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(uploadFailure(errors))
        })
      })
  }
}

export function startConversation(id, callback) {
  return (dispatch) => {
    dispatch(startConversationRequest())

    return api(`api/v1/job_applications/${id}/start_conversation`, {})
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(startConversationSuccess(json))
        callback(json)
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(startConversationFailure(errors))
        })
      })
  }
}

export function addNotes(keyName, jobApplicationId, notes, callback={}) {
  const config = {
    method: 'POST',
    body: JSON.stringify({notes: notes})
  }

  return (dispatch) => {
    dispatch(addNotesRequest())

    return api(`api/v1/${keyName}/${jobApplicationId}/add_notes`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(addNotesSuccess(json))
        if (callback) callback()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(addNotesFailure(errors))
        })
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: {},
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: errors
      }
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        errors: {},
        result: payload
      })
    case UPDATE_FAILURE:
      return {
        ...state,
        errors: errors,
        updating: false,
        updated: false
      }
    case START_CONVERSATION_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case START_CONVERSATION_SUCCESS:
      return Object.assign({}, state, {
        loading: false
      })
    case START_CONVERSATION_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: errors
      })
    case ADD_NOTES_REQUEST:
      return Object.assign({}, state, {
        addingNotes: true
      })
    case ADD_NOTES_SUCCESS:
      return Object.assign({}, state, {
        addingNotes: false,
        addedNotes: true,
        errors: {},
        result: payload
      })
    case ADD_NOTES_FAILURE:
      return {
        ...state,
        addingNotes: false,
        addedNotes: false,
        errors: errors
      }
    case UPLOAD_REQUEST:
      return Object.assign({}, state, {
        uploading: true
      })
    case UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        uploading: false,
        uploaded: true,
        errors: {},
        result: payload
      })
    case UPLOAD_FAILURE:
      return {
        ...state,
        errors: errors,
        uploading: false,
        uploaded: false
      }
    default:
      return state
  }
}
